"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestTabLeadership = void 0;
const broadcast_channel_1 = require("broadcast-channel");
const requestTabLeadership = () => {
    const electionChannel = new broadcast_channel_1.BroadcastChannel('streem', { webWorkerSupport: false });
    const election = (0, broadcast_channel_1.createLeaderElection)(electionChannel);
    return election.awaitLeadership();
};
exports.requestTabLeadership = requestTabLeadership;
//# sourceMappingURL=active_tab_election.js.map